import { createFileRoute, redirect } from "@tanstack/react-router";

export const Route = createFileRoute("/portal/organisation/theme")({
  beforeLoad: () => {
    throw redirect({ to: "/portal/platform/theme" });
  },
});
